import { render, staticRenderFns } from "./MatchCard.vue?vue&type=template&id=fd246168&scoped=true"
import script from "./MatchCard.vue?vue&type=script&lang=js"
export * from "./MatchCard.vue?vue&type=script&lang=js"
import style0 from "./MatchCard.vue?vue&type=style&index=0&id=fd246168&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd246168",
  null
  
)

export default component.exports